import CommonModal from "../../Common/CommonModal";
import { Btn } from "../../../../../AbstractElements";
import { ScrollingContent } from "../../../../../Constant";
import WedDesigners from "./WedDesigner";
import { useState } from "react";
import { UXDesigner } from "./UXDesigner";

const ScrollingModal = () => {
  const [scrollingModal, setScrollingModal] = useState(false);
  const scrollModaltoggle = () => setScrollingModal(!scrollingModal);
  return (
    <>
      <Btn color="success" type="button" onClick={scrollModaltoggle}>{ScrollingContent}</Btn>
      <CommonModal fade={true} isOpen={scrollingModal} toggle={scrollModaltoggle} title="Scrolling Modal">
        <WedDesigners />
        <UXDesigner />
      </CommonModal>
    </>
  );
};

export default ScrollingModal;
